// Entity definition for Collaborator

export interface ICollaborator {
    id?: number;
    name: string;
    patientID?: number;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    emailConfirmed: boolean;
    preferredLanguage: string;
    languages: codeName[];
    hasDependencies?: boolean;
}

export class Collaborator implements ICollaborator {
    id?: number;
    name: string;
    patientID?: number;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    emailConfirmed: boolean;
    preferredLanguage: string;
    languages: codeName[];
    hasDependencies?: boolean;

    comboboxItem: ICollaboratorcomboboxItem;

    constructor(data: ICollaborator) {
        this.id = data.id;
        this.name = data.name;
        this.patientID = data.patientID;
        this.firstName = data.firstName || '';
        this.lastName = data.lastName || '';
        this.email = data.email || '';
        this.role = data.role;
        this.emailConfirmed = data.emailConfirmed;
        this.comboboxItem = { value: data.id || 0, name: data.name, role: data.role };
        this.preferredLanguage = data.preferredLanguage || '';
        this.languages = data.languages;
        this.hasDependencies = data.hasDependencies || false;
    }

    get languagesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.languages);
    }

    private toCombobox(items: Array<codeName> = []): Array<{ value: string; label: string }> {
        return items.map(({ code, name }) => ({ value: code, label: name }));
    }
}

export interface IPartialCollaboratorPayload {
    patientID: number;
    role: string;
}

export interface ICollaboratorPayload {
    patientID?: number;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    preferredLanguage: string;
}

export interface ICollaboratorcomboboxItem {
    value: number;
    name: string;
    role?: string;
}

interface codeName {
    code: string;
    name: string;
}
